import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          专题推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.slice(0, 3).map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="relative w-full" style={{ paddingBottom: '66.67%' }}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 mb-1.5">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsData.slice(3, 5).map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-2/5" style={{ minHeight: '180px' }}>
                  <img
                    src={card.image}
                    alt={card.title}
                    className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    width="600"
                    height="400"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <h3 className="text-sm font-medium text-foreground-900 mb-1.5">{card.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}